// #region Base URL Configuration
export const base_url = window.APP_CONFIG?.BASE_URL || "https://localhost:7229";
// export const ExportPdfUrl = 'http://pdfgenerator.msisolutions.co.uk/form';
export const RedirectUri = window.location.origin;
// #endregion



// #region INTEGRATIONS
export const GetGisTokenData = base_url + "/api/Integration/GetGisToken";
// #endregion

// #region CONSTANTS
export const SelectedCompany = "selectedCompany";
export const CurrentWorkflowStep = "currentWorkflowStep";
export const SystemPropertiesTableName = "system_properties";
export const AccessTokenKeyInLocalStorage = "accessToken";
export const SuccessStatus = 1;
export const FailureStatus = 0;
export const LogoutStatus = -1;
// #endregion

// #region PUBLIC
export const GetDomainDataEndPoint = base_url + "/api/public/domain";
export const GetLabelsData = base_url + "/api/public/labels";
export const GetServicesData = base_url + "/api/public/services";
export const GetUserManualsData = base_url + "/api/public/user-manuals";
// #endregion

// #region DATABASE
export const GetEndPoint = base_url + "/api/Supabase/single";
export const GetAllEndPoint = base_url + "/api/Supabase/all";
export const PatchEndPoint = base_url + "/api/Supabase";
export const PutEndPoint = base_url + "/api/Supabase";
export const PostEndPoint = base_url + "/api/Supabase";
export const DeleteDBEndPoint = base_url + "/api/Supabase";
// #endregion

// #region COMPANIES
export const GetCompanyRolesData = base_url + "/api/Companies/roles";
export const GetUserCompaniesData = base_url + "/api/Companies/user";
export const GetBranchesCompanyEndPoint = base_url + "/api/Companies/branches";
export const ImportUserData = base_url + "/api/Companies/import";
// #endregion

// #region ROLES
export const UpdateUserRolesData = base_url + "/api/Roles/update-user-roles";
export const getUserRolesData = base_url + "/api/Roles/system";
// #endregion

// #region AUTHORIZATION
export const GetAccessDataEndPoint = base_url + "/api/Authorization/access-data";
export const GetAuthzCompaniesEndPoint = base_url + "/api/Authorization/companies";
export const GetCompanyRoleCatalogEndPoint = base_url + "/api/Authorization/companies";
export const GetAuthzPublicMenuEndPoint = base_url + "/api/Authorization/public-menu";
export const GetCompanyWorkflowsEndPoint = base_url + "/api/Authorization/companies"; // + /{companyId}/workflows
// #endregion

// #region USERS
export const GetLoggedInUserAccessData = base_url + "/api/Users/access-data";
export const GetCompanyUsersData = base_url + "/api/Users/company/data";
export const AddUserData = base_url + "/api/Users/company";
export const UnassignUserData = base_url + "/api/Users";
export const EditUserEndPoint = base_url + "/api/Users";
// #endregion

// #region GENERATORS
export const GetTransporterGeneratorsData = base_url + "/api/WasteManagement/generators";
export const DeleteTransporterGeneratorData = base_url + "/api/WasteManagement/generators";
export const AddTransporterGeneratorData = base_url + "/api/WasteManagement/generators";
export const EditTransporterGeneratorsData = base_url + "/api/WasteManagement/generators";
// #endregion

// #region CONTACTS/DELEGATES
export const AddTransporterContactData = base_url + "/api/WasteManagement/contacts";
export const EditTransporterContactData = base_url + "/api/WasteManagement/contacts";
export const DeleteTransporterContactData = base_url + "/api/WasteManagement/contacts";
export const GetTransporterContactsData = base_url + "/api/WasteManagement/contacts";
// #endregion

// #region TRUCKS
export const GetTransporterTrucksData = base_url + "/api/WasteManagement/trucks";
export const AddTransporterTruckData = base_url + "/api/WasteManagement/trucks";
export const DeleteTransporterTruckData = base_url + "/api/WasteManagement/trucks";
export const EditTransporterTruckData = base_url + "/api/WasteManagement/trucks";
// #endregion

// #region MOC
export const GetCRDetails = base_url + "/api/Integration/cr/details";
// #endregion

// #region TEMPLATES
export const GetAllTemplatesEndPoint = base_url + "/api/Templates/all";
export const DownloadTemplateEndPoint = base_url + "/api/Templates/download";
export const AddTemplateEndPoint = base_url + "/api/Templates/create";
export const DeleteTemplateEndPoint = base_url + "/api/Templates";
// #endregion

// #region FORMS
export const GetFormByIdEndPoint = base_url + "/api/Forms/form/";
export const EditFormEndPoint = base_url + "/api/Forms/editForm/";
export const GetAllFormsEndPoint = base_url + "/api/Forms/getForms";
export const CreateFormEndPoint = base_url + "/api/Forms/createForm";
export const CreateSubmissionEndPoint = base_url + "/api/Forms/createSubmission";
// #endregion

// #region FORMIO FORMS
export const GetFormioFormsEndPoint = base_url + "/api/FormioForms";
export const GetFormioFormByIdEndPoint = base_url + "/api/FormioForms/"; // + formId
export const CreateFormioFormEndPoint = base_url + "/api/FormioForms";
export const UpdateFormioFormEndPoint = base_url + "/api/FormioForms/"; // + formId
export const DeleteFormioFormEndPoint = base_url + "/api/FormioForms/"; // + formId
export const CreateFormioSubmissionEndPoint = base_url + "/api/FormioForms/"; // + formId + "/submissions"
// #endregion

// #region WORKFLOWS
export const DeleteProcessInstance = base_url + "/api/Workflow/DeleteProcessInstance";
export const GetWorkflowsEndpoint = base_url + "/api/Workflow/GetWorkflows";
export const GetTaskVariables = base_url + "/api/Workflow/GetTaskVariables";
export const cloneWorkflow = base_url + "/api/Workflow/CloneWorkflow";
export const PostregeneratePDF = base_url + "/api/Workflow/RegeneratePDF";
export const GetFormByUserTaskEndPoint = base_url + "/api/Workflow/GetFormByUserTask";
export const setAssignEndPoint = base_url + "/api/Workflow/SetAssignee";
export const PutProcessInstanceVariableEndPoint = base_url + "/api/Workflow/PutProcessInstanceVariable";
export const UnclaimTaskEndPoint = base_url + "/api/Workflow/UnClaimTask";
export const ClaimTaskEndPoint = base_url + "/api/Workflow/ClaimTask";
export const StartProcessByDefinitionKeyEndPoint = base_url + "/api/Workflow/StartProcessByDefinitionKey";
export const GetPendingTasksEndPoint = base_url + "/api/Workflow/PendingTasks";
export const GetWorkflowTasksPendingEndPoint = base_url + "/api/WorkflowTasks/PendingTasks";
export const SearchWorkflowTasksPendingEndPoint = base_url + "/api/WorkflowTasks/PendingTasks/Search";
export const ExecutePendingTaskEndPoint = base_url + "/api/Workflow/ExecutePendingTask";
export const ExecuteWorkflowTaskEndPoint = base_url + "/api/WorkflowTasks/Execute";
export const UnclaimWorkflowTaskEndPoint = base_url + "/api/WorkflowTasks/Unclaim";
export const DeleteWorkflowProcessEndPoint = base_url + "/api/WorkflowTasks/Delete";
export const ProcessDocumentsEndPoint = base_url + "/api/WorkflowTasks/Documents";
export const ProcessDocumentDownloadEndPoint = base_url + "/api/WorkflowTasks/Documents/Download";
export const GetTaskHistoryDataEndPoint = base_url + "/api/Workflow/GetTaskHistoryData";
export const GetWorkflowHistoryByCriteriaEndpoint = base_url + "/api/Workflow/WorkflowHistory";
export const StartProcessEndPoint = base_url + "/api/Workflow/StartProcess";
export const StartProcessByKeyEndPoint = base_url + "/api/Workflow/StartProcessByKey";
export const SubmitWorkflowEndPoint = base_url + "/api/Workflow/SubmitWorkflow";
// #endregion

// #region DASHBOARDS
export const GetSupersetDashboardEndPoint = base_url + "/api/Dashboards/superset/get-dashboards";
// #endregion

// #region IMPORT DATA
export const ImportCustomDataEndPoint = base_url + "/api/Import"
// #endregion
